<template>
  <div class="wallet-balance-info">
    <div class="wallet-balance-info__value wallet-balance-info__value_border">
      <p>{{ balanceObject?.value }}</p>
      <p>{{ getContent(popupsData, defaultLocalePopupsData, 'wallet.withdraw.balanceInfo.gameBalance') }}</p>
    </div>

    <div class="wallet-balance-info__value wallet-balance-info__value_tooltip">
      <p>{{ `${withdrawalBalance?.amount} ${withdrawalBalance?.currency}` }}</p>
      <p>{{ getContent(popupsData, defaultLocalePopupsData, 'wallet.withdraw.balanceInfo.withdrawable') }}</p>

      <tooltip-wrapper
        v-if="activeAccount?.bonusBalance"
        position="top"
        :arrow-offset="185"
        class="wallet-balance-info__tooltip"
      >
        <template #activator>
          <div class="wallet-limit__tooltip-btn">?</div>
        </template>

        <template #body>
          <div class="wallet-balance-info__bonus">
            <p>{{ getContent(popupsData, defaultLocalePopupsData, 'wallet.withdraw.balanceInfo.youCan') }}.</p>
            <p>
              {{ getContent(popupsData, defaultLocalePopupsData, 'wallet.withdraw.balanceInfo.bonusBalance') }}:
              <span>{{ bonusBalance?.amount }} {{ bonusBalance?.currency }}</span>
            </p>
          </div>
        </template>
      </tooltip-wrapper>
    </div>
  </div>
</template>
<script setup lang="ts">
  import type { IAccount } from '@skeleton/core/types';

  const { activeAccount, balanceObject } = defineProps<{
    balanceObject?: { value: string };
    activeAccount?: IAccount;
  }>();

  const { popupsData, defaultLocalePopupsData } = storeToRefs(useGlobalStore());

  const { formatBalance, getContent } = useProjectMethods();

  const withdrawalBalance = computed(() => {
    const temp = formatBalance(activeAccount?.currency, activeAccount?.withdrawalBalance);
    return {
      currency: activeAccount?.currency,
      amount: parseFloat(temp.amount.toFixed(4)).toString(),
    };
  });

  const bonusBalance = computed(() => {
    return formatBalance(activeAccount?.currency, activeAccount?.bonusBalance);
  });
</script>

<style src="~/assets/styles/components/wallet/balance-info.scss" lang="scss" />
